import {
    startOfDay,
    endOfDay,
    subDays,
    addDays,
    endOfMonth,
    isSameDay,
    isSameMonth,
    addHours
} from 'date-fns';

export class CalendarFakeDb
{

    public static data = [
        {
            id  : 'events',
            data: [
                {
                    start: startOfDay('2019-09-11'),
                    title: 'Nuevo Evento',
                    allDay: true,
                    color: {
                        primary: '#FF9800',
                        secondary: '#FFE0B2'
                    },
                    resizable: {
                        beforeStart: true, 
                        afterEnd: true
                    },
                    draggable: true,
                    meta : {
                        location: 'Pereira',
                        notes: 'Hola Mundo'
                    }
                }
            ]
        }


        /* {
            id  : 'events',
            data: [
                {
                    start    : subDays(startOfDay(new Date()), 1),
                    end      : addDays(new Date(), 1),
                    allDay   : true,
                    color    : {
                        primary  : '#F44336',
                        secondary: '#FFCDD2'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd   : true
                    },
                    draggable: true,
                    meta     : {
                        location: 'Los Angeles',
                        notes   : 'Eos eu verear adipiscing, ex ornatus denique iracundia sed, quodsi oportere appellantur an pri.'
                    }
                },
                {
                    start    : startOfDay(new Date()),
                    title    : 'An event with no end date',
                    allDay   : false,
                    color    : {
                        primary  : '#FF9800',
                        secondary: '#FFE0B2'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd   : true
                    },
                    draggable: true,
                    meta     : {
                        location: 'Los Angeles',
                        notes   : 'Eos eu verear adipiscing, ex ornatus denique iracundia sed, quodsi oportere appellantur an pri.'
                    }
                },
                {
                    start: startOfDay('2019-09-11'),
                    title: 'Nuevo Evento',
                    allDay: true,
                    color: {
                        primary: '#FF9800',
                        secondary: '#FFE0B2'
                    },
                    resizable: {
                        beforeStart: true, 
                        afterEnd: true
                    },
                    draggable: true,
                    meta : {
                        location: 'Pereira',
                        notes: 'Hola Mundo'
                    }
                },
                {
                    start    : subDays(endOfMonth(new Date()), 3),
                    end      : addDays(endOfMonth(new Date()), 3),
                    title    : 'A long event that spans 2 months',
                    allDay   : false,
                    color    : {
                        primary  : '#1E90FF',
                        secondary: '#D1E8FF'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd   : true
                    },
                    draggable: true,
                    meta     : {
                        location: 'Los Angeles',
                        notes   : 'Eos eu verear adipiscing, ex ornatus denique iracundia sed, quodsi oportere appellantur an pri.'
                    }
                },
                {
                    start    : addHours(startOfDay(new Date()), 2),
                    end      : new Date(),
                    title    : 'A draggable and resizable event',
                    allDay   : false,
                    color    : {
                        primary  : '#673AB7',
                        secondary: '#D1C4E9'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd   : true
                    },
                    draggable: true,
                    meta     : {
                        location: 'Los Angeles',
                        notes   : 'Eos eu verear adipiscing, ex ornatus denique iracundia sed, quodsi oportere appellantur an pri.'
                    }
                },
                {
                    start: startOfDay('2019-09-23'),
                    title: 'Nuevo Evento',
                    facturacion: {
                        electronico: 1,
                        fisico: 0
                    },
                    telefono: '213665656',
                    celular: '4547421245',
                    jornada: 'Mañana',
                    direccion: {
                        sistemas: 'Cra3',
                        factura: 'Cra3#23'
                    },
                    observacion: {
                        cobros: 'Hola',
                        cartera: 'Adios'
                    },
                    cobrador: {
                        codigo: '1233871',
                        actividad: 'Cobro'
                    }
                },
                {
                    start: '2019-11-01',
                    title: 'VitalPereira'
                }
            ]
        } */
    ];
}
